export default "__VITE_ASSET__269b000c__"